import React from 'react';

import { Card } from 'ui';

import ShippingDetail from './ShippingDetail';

type Props = {
  ticket: BackendPublic.TicketDetail;
};

const HIDE_STATUSES = ['CANCELED', 'REFUNDED', 'DECLINED', 'FAILURE', 'WAITING'];

function TransportList({ ticket }: Props) {
  if (!ticket.shipping || ticket.shipping.length === 0) return null;

  return (
    <Card flat>
      <Card.Content>
        <div className="space-y-4">
          {ticket.shipping
            .filter((shipping) => !HIDE_STATUSES.includes(shipping.status))
            .map((shipping) => (
              <ShippingDetail shipping={shipping} />
            ))}
        </div>
      </Card.Content>
    </Card>
  );
}

export default TransportList;
